<template>
  <section style="background:#DDD">
    <Banner value="Material Publicitário"/>

    <section style="background:#DDD">
      <v-container grid-list-xl>
        <v-layout row wrap my-2>
          <v-flex xs12>
            <p class="lead" style="text-align:center !important">
              Veja e faça o download do logotipo e dos materiais publicitários da escola.
              Lembramos que o uso do logotipo oficial da Escola Engenho só poderá ser feito após autorização formal da direção e sempre respeitando o padrão de cores e formatos pré estabelecidos.
            </p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section class="section">
      <Video/>
    </section>

    <section class="section" style="background:#dddddd">
      <v-container grid-list-xl>
        <v-layout row wrap my-2>
          <v-flex xs12>
            <h2 class="lead" style="text-align:center !important;">
              Artes para outdoor
              <small>Clique para baixar a arte desejada</small>
            </h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap my-2>
          <VueGallery :images="$store.getters.outdoorLgs" :index="index" @close="index = null"></VueGallery>
          <v-flex v-for="(image, i) in $store.state.outdoors" :key="i" xs12 sm12 md6>
            <h4>{{image.title}}</h4>
            <v-hover>
              <v-card
                flat
                tile
                class="d-flex"
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`"
              >
                <a href="#" @click.prevent="index = i">
                  <v-img :src="image.sm" class="grey lighten-2">
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="blue lighten-5"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </a>
              </v-card>
            </v-hover>
          </v-flex>

          <!-- 
          <v-flex xs12 sm12 md6 v-for="(o, i) in $store.state.outdoors" :key="i">
            <a :href="o.lg" target="_blank">
              <v-hover>
                <img
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 12 : 2}`"
                  :src="o.sm"
                  :alt="o.title"
                  style="width:100%"
                >
              </v-hover>
            </a>
          </v-flex>-->
        </v-layout>
      </v-container>
    </section>
  </section>
</template>

<script>
import Banner from "../../components/Banner";
import Video from "../../components/espaco/Video.vue";
import VueGallery from "vue-gallery";

export default {
  data: () => ({
    index: null
  }),
  components: {
    Banner,
    Video,
    VueGallery
  }
};
</script>

<style lang="scss" scoped>
p,
h2 {
  text-align: justify !important;
}
</style>

